// extracted by mini-css-extract-plugin
export default {"table":"RowSelectionTable_table__OU8Db"};